import { useEffect, useRef } from 'react'
import { getChapterProcessingStatus, parseChapterStatus } from 'src/apis/bookAPI'
import { ChapterData } from 'src/interfaces'

const DEFAULT_INTERVAL_MS = 5000

export const mergeChapterStatusUpdate = (
	current: ChapterData | null,
	statusChapter: ChapterData | null,
): ChapterData | null => {
	if (!current || !statusChapter) return current

	return {
		...current,
		...statusChapter,
		id: current.id,
		title: current.title ?? statusChapter.title,
		content: current.content?.length ? current.content : statusChapter.content,
		audio_details: statusChapter.audio_details?.length
			? statusChapter.audio_details
			: current.audio_details,
		original_doc_url:
			statusChapter.original_doc_url ?? current.original_doc_url ?? null,
	}
}

export function useChapterStatusPoll(
	chapterId: string | undefined,
	opened: boolean,
	onStatus: (statusChapter: ChapterData | null) => void,
	intervalMs = DEFAULT_INTERVAL_MS,
) {
	const onStatusRef = useRef(onStatus)
	onStatusRef.current = onStatus

	useEffect(() => {
		if (!opened || !chapterId) return

		let cancelled = false

		const poll = async () => {
			try {
				const res = await getChapterProcessingStatus(chapterId)
				if (cancelled) return
				onStatusRef.current(parseChapterStatus(res))
			} catch {
				// Silent on poll errors — initial load handles user-facing errors
			}
		}

		const timerId = window.setInterval(poll, intervalMs)
		return () => {
			cancelled = true
			window.clearInterval(timerId)
		}
	}, [chapterId, intervalMs, opened])
}
